module.exports = __webpack_public_path__ + "static/media/rebus-logo.52287416.png";